module.exports = __webpack_public_path__ + "files/081a264c13617ac1e7af61a04c2a048c.png";